import _ from "lodash";
import React from "react";
import classes from "./LoginForm.scss";
import {FormTextInput} from "UIComponents/InputTextField";
import { Button } from "@toddle-edu/ds-web";
import { getLoginDataState } from "Login/modules/LoginModule";
import classNames from "classnames";
import { onEnterOrSpaceKeyDown } from "Utils";

class LoginForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.inputRefs = {};
  }

  UNSAFE_componentWillMount = () => {
    const { resetScreen, isNewLoginFlowEnabled } = this.props;
    if (!isNewLoginFlowEnabled) {
      resetScreen("loginForm");
    }
  };

  componentDidMount = () => {
    const {
      data: { email = "" },
      isNewLoginFlowEnabled,
    } = this.props;
    if (isNewLoginFlowEnabled) {
      if (email.length > 0) {
        this.inputRefs?.password?.focus();
      }
    }
  };

  onForgotPasswordClick = () => {
    const { updateCurrentScreen, userType, role } = this.props;
    if (userType === "staff" && role === "visitor") {
      updateCurrentScreen({
        type: "forgotPassword",
        paramsToBeRemoved: ["role"],
      });
    } else {
      updateCurrentScreen({ type: "forgotPassword" });
    }
  };

  onBackClick = () => {
    const {
      updateCurrentScreen,
      userType,
      role,
      updateInputField,
      isNewLoginFlowEnabled,
    } = this.props;

    if (isNewLoginFlowEnabled) {
      updateInputField({});
      updateInputField({}, "loginFormV2");
    }

    switch (userType) {
      case "staff": {
        if (role === "visitor") {
          updateCurrentScreen({ type: "visitorLogin" });
        } else {
          updateCurrentScreen({ type: "teacherLogin" });
        }
        break;
      }
      case "student":
        updateCurrentScreen({ type: "studentLogin" });
        break;
      case "parent":
        updateCurrentScreen({ type: "parentLogin" });
        break;
    }
  };

  onSignInClick = async () => {
    const { updateInputField, data: { email } = {} } = this.props;
    await updateInputField({
      email: _.trim(email),
    });

    const { onSignInClick, showErrorToast } = this.props;
    const errorCount = this.isValid();
    showErrorToast({ errorCount });
    if (errorCount > 0) {
      return;
    }

    onSignInClick();
  };

  isValid = () => {
    const refKeys = Object.keys(this.inputRefs);
    let errorCount = 0;
    _.forEach(refKeys, key => {
      if (this.inputRefs[key]) {
        errorCount += this.inputRefs[key].isValid();
      }
    });

    return errorCount;
  };

  onPasswordEnter = () => {
    this.onSignInClick();
  };

  onSignInWithOTPClick = async () => {
    const {
      updateCurrentScreen,
      updateInputField,
      data: { email } = {},
      userType,
      role,
      generateEmailOTPForSignIn,
    } = this.props;

    const errorCount = this.inputRefs?.["email"]?.isValid();

    if (errorCount > 0) {
      return;
    }

    const { isSuccess } = await generateEmailOTPForSignIn({
      userType,
      role,
      email,
    });

    if (isSuccess) {
      updateInputField({ email }, getLoginDataState({ userType, role }));
      updateCurrentScreen({ type: "loginFormV2" });
    }
  };

  getBackButtonText = () => {
    const { userType, role, isNewLoginFlowEnabled } = this.props;
    if (isNewLoginFlowEnabled) {
      return "Go back";
    }
    switch (userType) {
      case "student":
        return "Student account";
      case "staff":
        if (role === "visitor") return "Visitor account";
        return "Teacher account";
    }
  };

  getHeaderText = () => {
    const { userType, role } = this.props;
    switch (userType) {
      case "student":
        return "Student account";
      case "staff":
        if (role === "visitor") return "Visitor account";
        return "Teacher account";
      case "parent":
        return "Family account";
    }
  };

  render() {
    const {
      updateInputField,
      checkEmailVerification,
      data: { email, password } = {},
      renderBackButtonComponent,
      customStyle: { headerStyle, headerStyleV2 } = {},
      userType,
      role,
      renderTradeMarkText,
      isNewLoginFlowEnabled,
      isOTPLoginEnabled,
      isOrgWorkspaceLoginPage = false,
    } = this.props;

    const isVisitor = userType === "staff" && role === "visitor";

    const innerContainerStyles = classNames({
      [classes.innerContainer]: true,
      [classes.innerContainerV2]: isNewLoginFlowEnabled,
    });

    const inputsContainerStyles = classNames({
      [classes.inputsContainer]: true,
      [classes.inputsContainerV2]: isNewLoginFlowEnabled,
    });

    const inputContainerStyles = classNames({
      [classes.inputContainer]: true,
      [classes.inputContainerV2]: isNewLoginFlowEnabled,
    });

    const containerStyle = {
      paddingTop: isOrgWorkspaceLoginPage ? "13%" : "19.5%",
    };

    return (
      <div className={classes.container} style={containerStyle}>
        <div>
          {renderBackButtonComponent({
            onClick: this.onBackClick,
            buttonText: this.getBackButtonText(),
          })}
          {isNewLoginFlowEnabled ? (
            <div style={headerStyleV2}>{this.getHeaderText()}</div>
          ) : (
            <div style={headerStyle}> {"Sign in to Toddle"} </div>
          )}
          {/* will uncomment and update text when cas external is enabled for all prod schools */}
          {/* {isVisitor ? (
            <div
              className={classes.subHeader}
            >{`Programme evaluation team member sign in`}</div>
          ) : null} */}

          <div className={innerContainerStyles}>
            <div className={inputsContainerStyles}>
              <div className={inputContainerStyles}>
                <FormTextInput
                  testId="input-login-email"
                  ref={ref => (this.inputRefs["email"] = ref)}
                  textInputLabel={"Email*"}
                  value={email}
                  name={"email"}
                  placeholder={"Enter your email"}
                  updateInputField={updateInputField}
                  error={"Enter email address"}
                  customValidation={checkEmailVerification}
                  size={"large"}
                  autoComplete={"off"}
                />
              </div>
              <div className={classes.inputContainer}>
                {isNewLoginFlowEnabled ? (
                  <FormTextInput
                    testId="input-login-password"
                    textInputLabel={"Password*"}
                    ref={ref => (this.inputRefs["password"] = ref)}
                    value={password}
                    name={"password"}
                    type={"password"}
                    placeholder={"Enter Password"}
                    updateInputField={updateInputField}
                    error={"Enter password"}
                    size={"large"}
                    onEnter={this.onPasswordEnter}
                    autoComplete={"off"}
                    labelSuffix={
                      isOTPLoginEnabled ? (
                        <span
                          className={classes.labelSuffixText}
                          onClick={this.onSignInWithOTPClick}
                          data-test-id="input-signin-with-otp"
                          onKeyDown={e => {
                            onEnterOrSpaceKeyDown(e, this.onSignInWithOTPClick);
                          }}
                          tabIndex="0"
                        >
                          {"Sign in using OTP"}
                        </span>
                      ) : null
                    }
                  />
                ) : (
                  <>
                    <div className={classes.inputLabelContainer}>
                      <span className={classes.label}>Password*</span>
                      <Button
                        data-test-id="button-forgot-password"
                        variant={"inline-progressive"}
                        size={"small"}
                        onClick={this.onForgotPasswordClick}
                      >{`Forgot password?`}</Button>
                    </div>
                    <FormTextInput
                      testId="input-login-email"
                      ref={ref => (this.inputRefs["password"] = ref)}
                      value={password}
                      name={"password"}
                      type={"password"}
                      placeholder={"Enter Password"}
                      updateInputField={updateInputField}
                      error={"Enter password"}
                      size={"large"}
                      onEnter={this.onPasswordEnter}
                      autoComplete={"off"}
                    />
                  </>
                )}
              </div>
            </div>
            {isNewLoginFlowEnabled ? (
              <div className={classes.middleContainer}>
                <Button
                  className={classes.forgotPasswordBtn}
                  data-test-id="button-forgot-password"
                  variant={"inline-progressive"}
                  size={"small"}
                  onClick={this.onForgotPasswordClick}
                >{`Forgot password?`}</Button>
              </div>
            ) : null}
            <div className={classes.bottomContainer}>
              <Button
                testId="button-sign-in"
                variant={"destructive"}
                size={"large"}
                onClick={this.onSignInClick}
                isFullWidth={true}
              >
                {"Sign in"}
              </Button>
            </div>
          </div>
        </div>
        <div>
          {renderTradeMarkText({
            align: "left",
          })}
        </div>
      </div>
    );
  }
}

export default LoginForm;
